var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3;
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Fragment, useEffect, useState } from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { Transition, Dialog, Tab } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import { store, useAppDispatch, useAppSelector, } from '../../../store';
import { updateShowRoomSettingsModal } from '../../../store/slices/roomSettingsSlice';
import DataSavings from './dataSavings';
import Notification from './notification';
import ApplicationSettings from './application';
import Ingress from './ingress';
const isShowRoomSettingsModalSelector = createSelector(_react_refresh_temp_1 = (state) => state.roomSettings, (roomSettings) => roomSettings.isShowRoomSettingsModal);
$RefreshReg$(_react_refresh_temp_1, "isShowRoomSettingsModalSelector$createSelector");
const RoomSettings = () => {
    var _a, _b, _c, _d;
    _react_refresh_temp_3();
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const s = store.getState();
    const serverVersion = s.session.serverVersion;
    const copyright_conf = (_b = (_a = s.session.currentRoom) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.copyright_conf;
    const ingressFeatures = (_d = (_c = s.session.currentRoom) === null || _c === void 0 ? void 0 : _c.metadata) === null || _d === void 0 ? void 0 : _d.room_features.ingress_features;
    const isShowRoomSettingsModal = useAppSelector(isShowRoomSettingsModalSelector);
    const [categories, setCategories] = useState({
        'header.room-settings.application': [
            {
                id: 1,
                elm: _jsx(ApplicationSettings, {}),
            },
        ],
        'header.room-settings.data-savings': [
            {
                id: 2,
                elm: _jsx(DataSavings, {}),
            },
        ],
        'header.room-settings.notifications': [
            {
                id: 3,
                elm: _jsx(Notification, {}),
            },
        ],
    });
    useEffect(() => {
        var _a, _b, _c;
        if (((_c = (_b = (_a = s.session) === null || _a === void 0 ? void 0 : _a.currentUser) === null || _b === void 0 ? void 0 : _b.metadata) === null || _c === void 0 ? void 0 : _c.is_admin) &&
            (ingressFeatures === null || ingressFeatures === void 0 ? void 0 : ingressFeatures.is_allow)) {
            categories['header.room-settings.ingress'] = [
                {
                    id: 4,
                    elm: _jsx(Ingress, {}),
                },
            ];
        }
        setCategories(categories);
    }, []);
    const closeModal = () => {
        dispatch(updateShowRoomSettingsModal(false));
    };
    const classNames = (...classes) => {
        return classes.filter(Boolean).join(' ');
    };
    const displayBottomText = () => {
        let text = (copyright_conf === null || copyright_conf === void 0 ? void 0 : copyright_conf.display) ? `${copyright_conf === null || copyright_conf === void 0 ? void 0 : copyright_conf.text}&nbsp;` : '';
        text += t('plugnmeet-server-client-version', {
            server: serverVersion,
            client: PNM_VERSION,
        });
        return (_jsx("div", { className: "absolute inset-x-0 bottom-0 text-center text-xs dark:text-darkText", dangerouslySetInnerHTML: { __html: text } }));
    };
    const showTabItems = () => {
        return (_jsx("div", { className: "max-w-full", children: _jsxs(Tab.Group, { vertical: true, children: [_jsx(Tab.List, { className: "flex p-1 space-x-1 bg-primaryColor rounded-xl", children: Object.keys(categories).map((category) => (_jsx(Tab, { className: ({ selected }) => classNames('w-full py-1 text-xs sm:text-sm leading-5 font-medium text-secondaryColor rounded-lg outline-none', 'ring-white ring-opacity-60', selected
                                ? 'bg-white dark:bg-secondaryColor shadow text-primaryColor dark:text-white'
                                : 'hover:bg-white/[0.12] hover:text-white'), children: t(category) }, category))) }), _jsx(Tab.Panels, { className: "mt-2", children: Object.values(categories).map((posts, idx) => (_jsx(Tab.Panel, { className: "bg-transparent rounded-xl p-3", children: _jsx("ul", { children: posts.map((post) => (_jsx("li", { children: post.elm }, post.id))) }) }, idx))) })] }) }));
    };
    const render = () => {
        return (_jsx(_Fragment, { children: _jsx(Transition, { appear: true, show: isShowRoomSettingsModal, as: Fragment, children: _jsx(Dialog, { as: "div", className: "fixed inset-0 z-[9999] overflow-y-auto", onClose: () => false, children: _jsxs("div", { className: "min-h-screen px-4 text-center", children: [_jsx(Transition.Child, { as: Fragment, enter: "ease-out duration-300", enterFrom: "opacity-0", enterTo: "opacity-100", leave: "ease-in duration-200", leaveFrom: "opacity-100", leaveTo: "opacity-0", children: _jsx(Dialog.Overlay, { className: "fixed inset-0 bg-black opacity-30" }) }), _jsx("span", { className: "inline-block h-screen align-middle", "aria-hidden": "true", children: "\u200B" }), _jsx(Transition.Child, { as: Fragment, enter: "ease-out duration-300", enterFrom: "opacity-0 scale-95", enterTo: "opacity-100 scale-100", leave: "ease-in duration-200", leaveFrom: "opacity-100 scale-100", leaveTo: "opacity-0 scale-95", children: _jsxs("div", { className: "inline-block w-full h-[25rem] max-w-2xl py-6 px-4 lg:px-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white dark:bg-darkPrimary shadow-xl rounded-2xl", children: [_jsxs("button", { className: "close-btn absolute top-8 ltr:right-6 rtl:left-6 w-[25px] h-[25px] outline-none", type: "button", onClick: () => closeModal(), children: [_jsx("span", { className: "inline-block h-[1px] w-[20px] bg-primaryColor dark:bg-darkText absolute top-0 left-0 rotate-45" }), _jsx("span", { className: "inline-block h-[1px] w-[20px] bg-primaryColor dark:bg-darkText absolute top-0 left-0 -rotate-45" })] }), _jsx(Dialog.Title, { as: "h3", className: "text-lg font-medium leading-6 text-gray-900 dark:text-white mb-2 ltr:text-left rtl:text-right", children: t('header.room-settings.title') }), _jsx("hr", {}), _jsx("div", { className: "mt-2", children: showTabItems() }), displayBottomText()] }) })] }) }) }) }));
    };
    return _jsx(_Fragment, { children: isShowRoomSettingsModal ? render() : null });
};
_react_refresh_temp_2 = RoomSettings;
$RefreshReg$(_react_refresh_temp_2, "RoomSettings");
_react_refresh_temp_3(RoomSettings, "omlhXx6P1u5ICDU0C2jpV5hqsHs=", false, () => [useAppDispatch, useTranslation, useAppSelector]);
export default RoomSettings;
